import { Customer, LocationDataGeocoded } from '@sc/data-access-models';

export interface AppointmentSheetValidationData {
  replacementVehicle: boolean;
  locationChoice?: 'center' | 'outside';
  location: LocationDataGeocoded;
  customer: Customer;
}
